import { ResponseType } from '../types/QuestionsTabType';

const sortOptions: Array<{
  key: string;
  value: number;
  label: string;
}> = [
  {
    key: 'id',
    value: 0,
    label: 'ID',
  },

  {
    key: 'firstName',
    value: 6,
    label: 'First name',
  },

  {
    key: 'lastName',
    value: 7,
    label: 'Last name',
  },
  {
    key: 'alternateName',
    value: 8,
    label: 'Alternate name',
  },
  {
    key: 'cid',
    value: 2,
    label: 'CID',
  },
  {
    key: 'sid',
    value: 3,
    label: 'SID',
  },
  {
    key: 'pid',
    value: 4,
    label: 'PID',
  },

  {
    key: 'primaryPhone',
    value: 10,
    label: 'Primary phone number',
  },
  {
    key: 'city',
    value: 13,
    label: 'City',
  },
  {
    key: 'state',
    value: 14,
    label: 'State',
  },
];

const successMsg: string = 'Person updated successfully.';

const errorMsg: string = 'There was an error while updating the responses.';

const callDocBtnTitle = 'View call document';

const callDocBtnDisableTitle =
  'Call Document is unavailable because this call has not been finalized.';

const warningMsg: string =
  'There are required field(s) to be filled in Person information.';

const selectOptions: Array<{ value: string; label: string }> = [
  { value: '', label: '' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

function getphnType(
  phoneTypeList: Array<{ Id: number; Description: string }> | undefined,
  id: string,
) {
  if (phoneTypeList && id) {
    const value = phoneTypeList?.find(
      (item: any) => item?.Id?.toString() === id,
    );
    return value;
  }
}

function getCountry(
  countryList:
    | Array<{
        Abbreviation: string;
        ISDCode: string;
        Id: number;
        Name: string;
        SortOrder: number;
      }>
    | undefined,
  id: number,
) {
  if (countryList && id) {
    const value = countryList?.find((item: any) => item?.Id === id);
    return value;
  }
}

function getStateProvince(stateProvince: any, id: number) {
  if (stateProvince && id) {
    const value = stateProvince?.find((item: any) => item?.Id === id);
    return value;
  }
}

function getGenderObject(genderList: any, id: number) {
  if (genderList && id) {
    const value = genderList?.find((item: any) => item?.Id === id);
    return value;
  }
}

//restricted questions check

function restrictedQuestions(item: ResponseType) {
  if (
    item?.Type !== 'Scheduler' &&
    item?.Type !== 'Resources' &&
    item?.Type !== 'Bed Request' &&
    item?.Type !== 'PDF' &&
    item?.Type !== 'Link' &&
    item?.Type !== 'Outbound Call' &&
    item?.Type !== 'Preliminary Report' &&
    item?.Type !== 'Tracker' &&
    item?.Type !== 'Display Only'
  ) {
    return true;
  } else return false;
}

const restrictedTypes = new Set([
  'Scheduler',
  'Resources',
  'Bed Request',
  'PDF',
  'Link',
  'Outbound Call',
  'Preliminary Report',
  'Tracker',
  'Display Only',
]);

const cancelAlertWarning =
  'Please note you have unsaved changes in the Personal details tab';

const sortDataOption = [
  { label: 'Call ID', value: 0 },
  { label: 'Case ID', value: 1 },
  { label: 'Start', value: 2 },
  { label: 'End', value: 3 },
  { label: 'Service type', value: 4 },
  { label: 'Level of care', value: 5 },
];

const sortDataOptionPersonHistory = [
  { label: 'PersonId', value: 0 },
  { label: 'PersonDetailCategory', value: 1 },
  { label: 'ColumnName', value: 2 },
  { label: 'UpdatedFrom', value: 3 },
  { label: 'PreviousValue', value: 4 },
  { label: 'NewValue', value: 5 },
  { label: 'UpdatedBy', value: 6 },
  { label: 'UpdatedAt', value: 7 },
];

const disableQnText =
  'This response is not editable as it is associated with limited access.';

export {
  sortOptions,
  successMsg,
  errorMsg,
  warningMsg,
  selectOptions,
  getphnType,
  getCountry,
  getStateProvince,
  getGenderObject,
  restrictedQuestions,
  cancelAlertWarning,
  sortDataOption,
  sortDataOptionPersonHistory,
  callDocBtnDisableTitle,
  callDocBtnTitle,
  restrictedTypes,
  disableQnText,
};
